import { EventRoleStatus } from '@type/db-types';
import EventCard from './EventCard';
import { Box, IconButton, Tooltip } from '@mui/material';
import TableRowsIcon from '@mui/icons-material/TableRows';
import Grid from '@mui/material/Grid2';
import { EventContextValues } from '@hooks/useEventContext';
import { eventFromRow } from '@utils/event-utils';

export default function EventsCardsGrid({
    events,
    onSelectEvent,
    setViewType,
}: {
    events: EventRoleStatus[] | null;
    onSelectEvent: (event: EventContextValues['event']) => void;
    setViewType: (viewType: 'table' | 'card') => void;
}) {
    return (
        <Box flex={1}>
            <Box justifyContent="space-between" display="flex" margin="2rem" marginBottom={0}>
                <h3>Events</h3>
                <Tooltip title="Change view">
                    <IconButton onClick={() => setViewType('table')} size="large">
                        <TableRowsIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            <Grid container spacing={4} padding={4} paddingTop={2}>
                {events?.map((event, index) => (
                    <Grid size={{ sm: 12, md: 6 }} key={index}>
                        <EventCard
                            event={event}
                            moreInfoAction={() => onSelectEvent(eventFromRow(event))}
                            selectedIds={[]}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
